import { render } from "./TicketChatPanel.vue?vue&type=template&id=078ce505&scoped=true"
import script from "./TicketChatPanel.vue?vue&type=script&lang=js"
export * from "./TicketChatPanel.vue?vue&type=script&lang=js"

import "./TicketChatPanel.vue?vue&type=style&index=0&id=078ce505&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-078ce505"]])

export default __exports__